import { ENCRYPTED_WALLET_ID_KEY } from "./config";

export const ENC_WALLET_ID_REGEX = /^U2FsdGVkX1[A-Za-z0-9+/=_-]{10,}$/;

export function readEnc() {
  try {
    return localStorage.getItem(ENCRYPTED_WALLET_ID_KEY);
  } catch {
    return null;
  }
}

export function saveEnc(enc, { force = false } = {}) {
  if (!enc) return null;
  const existing = readEnc();
  if (existing && !force) {
    setTimeout(enforce, 0);
    return existing;
  }
  try {
    localStorage.setItem(ENCRYPTED_WALLET_ID_KEY, enc);
  } catch {}
  setTimeout(enforce, 0);
  return enc;
}

export function clearEnc() {
  try {
    localStorage.removeItem(ENCRYPTED_WALLET_ID_KEY);
  } catch {}
  const hash = window.location.hash || "#/";
  const after = hash.replace(/^#\/?/, "");
  const parts = after.split("/").filter(Boolean);
  if (parts.length === 0) return;

  if (ENC_WALLET_ID_REGEX.test(parts[parts.length - 1])) {
    const newHash = "#/" + parts.slice(0, -1).join("/");
    const newUrl = window.location.pathname + window.location.search + newHash;
    window.history.replaceState(null, "", newUrl);
  }
}

export function enforce() {
  const enc = readEnc();
  if (!enc) return;

  const hash = window.location.hash || "#/";
  const after = hash.replace(/^#\/?/, "");
  const parts = after.split("/").filter(Boolean);
  if (parts[0] === "CreatorHub" || parts[0] === "StakeHub" || parts[0] === "AccessNFTDetails" || parts[0] === "AccessNFTCheckout" || parts[0] === "BuckDetails" || parts[0] === "BrandClubDetails" || parts[0] === "BrandClubCheckout" || parts[0] === 'StarProfile') {
    return;
  }

  const last = parts[parts.length - 1] || "";
  const hasToken = ENC_WALLET_ID_REGEX.test(last);
  const baseParts = hasToken ? parts.slice(0, -1) : parts;
  const desiredHash = "#/" + [...baseParts, enc].join("/");

  if (hash !== desiredHash) {
    const newUrl = window.location.pathname + window.location.search + desiredHash;
    window.history.replaceState(null, "", newUrl);
  }
}

export function init() {
  enforce();
  window.removeEventListener("hashchange", enforce);
  window.addEventListener("hashchange", enforce);
}